import { render, staticRenderFns } from "./VuePlyr.vue?vue&type=template&id=6f1be8a6&"
import script from "./VuePlyr.vue?vue&type=script&lang=js&"
export * from "./VuePlyr.vue?vue&type=script&lang=js&"
import style0 from "plyr/dist/plyr.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports